export default __webpack_public_path__ + "static/media/Levitate D2.3 Levitate Initial exploitation plan.733e7e8f.pdf";